import { Theme } from '@mui/material/styles';

import { Icon } from '../../../Icon/Icon';

import { CopyButton, EmailContainer, EmailText } from './EmailCopyField.styled';

type EmailCopyFieldProps = {
  email: string;
  onCopy: () => void;
  isCopied: boolean;
};

export function EmailCopyField({
  email,
  onCopy,
  isCopied,
}: EmailCopyFieldProps) {
  return (
    <EmailContainer>
      <EmailText>{email}</EmailText>
      <CopyButton onClick={onCopy} size="small">
        <Icon
          name={isCopied ? 'check' : 'copy'}
          color={(theme: Theme) =>
            isCopied ? theme.palette.success.main : theme.palette.grey[700]
          }
        />
      </CopyButton>
    </EmailContainer>
  );
}
